<template>
	<div class="header-form">
		<div
			style="display: flex; justify-content: space-between; align-items: end"
		>
			<div style="width: 50%; display: flex; align-items: end">
				<span style="font-size: 16px; font-weight: 300; color: #2196f3">
					<slot />
				</span>
			</div>
			<slot name="actions" class="pull-right" />
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style scoped>
.header-form {
	border-bottom: 1px solid #2196f3;
	padding: 3px 0;
	margin: 12px 0 8px 0;
	justify-content: space-between;
}
.header-info {
	background: rgb(208 231 249);
	color: #00569b;
	border: 1px solid #9cd3ff;
	padding: 2px 6px;
	display: flex;
	margin: 5px 0;
	font-size: 11px;
	display: flex;
	align-items: center;
	border-radius: 3px;
}
</style>
